import { Presence } from '@sitecore-search/ui';
import { SpinnerProps } from 'types/Search/Search.Models';

/**
 * Spinner component for displaying loading states
 * @param loading - Whether the spinner should be visible and active
 */
const Spinner = ({ loading = false }: SpinnerProps) => {
  return (
    <Presence present={loading}>
      <div className="text-center">
        <div role="status">
          <svg
            aria-busy={loading}
            aria-hidden={!loading}
            focusable="false"
            viewBox="0 0 20 20"
            className="inline animate-spin w-10 text-light-fill-secondary"
          >
            <path
              fill="currentColor"
              d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </Presence>
  );
};

export default Spinner;
